<script setup lang="ts">
import { useSeoHead } from '~/composables/useSeoHead'

definePageMeta({
  hideDefaultTopNav: true,
  newsCategory: 'art_latest',
})

const { t } = useAppI18n()

useSeoHead({
  title: () => t('85598'),
  description: () => t('85599'),
  keywords: () => t('85598').replace(/\s*\|\s*WikiBit\s*$/i, ''),
})
</script>

<template>
  <NewsListContent />
</template>
